import { IAccountState } from '@mnz-modules/login/store/reducers/account.reducer';
import { IAuthState } from '@mnz-modules/login/store/reducers/auth.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getLoginState = createFeatureSelector<{ auth: IAuthState; account: IAccountState }>('login');

export const getLoading = createSelector(getLoginState, ({ auth }) => auth.loading);

export const getMessageFail = createSelector(getLoginState, ({ auth }) => auth.messageFail);

export const getInput = createSelector(getLoginState, ({ auth }) => auth.userInput);

export const getJwsToken = createSelector(getLoginState, ({ auth }) => auth.jwsToken);

export const getPrefilledEmail = createSelector(getLoginState, ({ auth }) => auth.prefilledEmail);
